import update from 'immutability-helper';

// ------------------------------------
// Constants
// ------------------------------------
export const SET_MERCHANT = 'SET_MERCHANT';
export const SET_THEME_NAME = 'SET_THEME_NAME';


export function setMerchant(merchantId) {
	return {
		type: SET_MERCHANT,
		merchantId,
	};
}

export function setThemeName(themeName) {
	return {
		type: SET_THEME_NAME,
		themeName,
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_MERCHANT]: (state, action) => update(state, {
		merchantId: { $set: action.merchantId },
	}),
	[SET_THEME_NAME]: (state, action) => update(state, {
		themeName: { $set: action.themeName },
	}),

};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
	merchantId: null,
	themeName: null,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
